module.exports = __webpack_public_path__ + "static/media/no_smoking.1211c4d8.svg";